import styled from 'styled-components';
import { Form } from '@unform/web';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }
`;
